{
  function addAriaLabels() {
    const asterisks = document.querySelectorAll('.gfield_required_asterisk')
    if (asterisks) {
      asterisks.forEach(el => el.setAttribute('aria-hidden', true))
    }
  }

  function removeNoValidate() {
    const gforms = document.querySelectorAll('.gform_wrapper form')
    if (gforms) {
      gforms.forEach(el => el.removeAttribute('novalidate'))
    }
  }

  function removeOnSubmit() {
    const submits = document.querySelectorAll('.gform_wrapper input[type="submit"]')
    if (submits) {
      submits.forEach(el => {
        el.removeAttribute('onclick')
        el.removeAttribute('onkeypress')
      })
    }
  }

  function addHTML5required() {
    const requiredInputs = document.querySelectorAll('.gform_wrapper [aria-required="true"]')
    if (requiredInputs) {
      requiredInputs.forEach(el => el.setAttribute("required", "required"))
    }
  }

  function ariaHideHoneypot() {
    document.querySelectorAll('.gfield--type-honeypot').forEach(el => el.setAttribute('aria-hidden', true))
    document.querySelectorAll('.gfield--type-honeypot label').forEach(el => el.setAttribute('aria-hidden', true))
    document.querySelectorAll('.gfield--type-honeypot input').forEach(el => el.setAttribute('aria-hidden', true))
    document.querySelectorAll('.gfield--type-honeypot label').forEach(el => el.setAttribute('focusable', false))
    document.querySelectorAll('.gfield--type-honeypot input').forEach(el => el.setAttribute('focusable', false))
    document.querySelectorAll('.gfield--type-honeypot input').forEach(el => el.setAttribute('tabindex', -1))
  }
  // function addEmailValidation(){
  //   const emailInputs = document.querySelectorAll('.gform_wrapper input[type="email"]')
  //   if(emailInputs){
  //     emailInputs.forEach(el => el.setAttribute("pattern", "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"))
  //   }
  // }

  // this doesn't matter because gforms does it's own validation to match a regex
  // function addTelValidation(){
  //   const emailInputs = document.querySelectorAll('.gform_wrapper input[type="tel"]')
  //   if(emailInputs){
  //     emailInputs.forEach(el => el.setAttribute("pattern", "\\([0-9]{3}\\)\\s[0-9]{3}\-[0-9]{4}"))
  //   }
  // }

  //after a form is rendered, update all inputs to use HTML5 validation
  function handlePostRender() {
    jQuery(document).on('gform_post_render', function () {
      addAriaLabels() //screen readers read "asterisk" which is annoying, remove it
      removeNoValidate() //gforms adds this to ignore HTML5 validations and run their own, remove it
      removeOnSubmit()
      addHTML5required()
      ariaHideHoneypot()
      // We don't need this because html5 has native email validation for type="email", that regex doesn't work anyway
      // addEmailValidation()
    })
  }

  function handleSuccess() {
    jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
      //add a role for screen readers
      const messages = document.querySelectorAll('.gform_confirmation_message')
      if (messages) {
        messages.forEach(el => el.setAttribute('role', 'alert'))

        //scroll the confirmation into view
        let top = jQuery(messages[0]).offset().top
        top -= document.querySelector('.main-header').offsetHeight
        jQuery('html, body').animate({ scrollTop: top }, 250)
      }
    })
  }

  function gravityformHelpers() {
    handlePostRender()
    handleSuccess()
  }

  gravityformHelpers()
}